<template>
<div class="section">
    <div class="columns is-multiline">

        <div :class="{'is-hidden-desktop':section.image}" class="column is-full  has-text-centered">
             <a class="is-uppercase is-size-3 section-title is-rounded is-large" :href="section.getProdListUrl">
                {{section.title}}
                <b-icon icon="arrow-right" size="is-small" class="m-l-5">
                </b-icon>
            </a>
        </div>

        <div v-if="section.image" class="column is-one-fifth is-hidden-touch">
            <a :href="section.getProdListUrl"><img class="section-img" v-if="section.image" :src="section.image" alt=""></a>
        </div>

        <div class="column " :class="section.image ? 'is-four-fifths' : 'is-full'">
            <b-carousel-list 
            :arrow-hover="false" 
            :as-indicator="false" 
            :has-drag="false" 
            v-model="model" 
            :repeat="true" 
            :data="section.products" 
            :items-to-show="4">
                <template slot="item" slot-scope="props">
                    <a @click="redirectTo(props.list.getDetailUrl)" >
                        <div class="card">
                            <div class="card-image has-text-centered">
                                <div class="img-overlay">
                                    <div class="img-overlay-btn">
                                        <b-button
                                        class="is-custom"
                                        rounded>
                                        <b-icon icon="eye" size="is-small"></b-icon>
                                        Ver producto                            
                                        </b-button>
                                    </div>
                                </div>
                                <div v-if="props.list.status == 'O'" class="tag is-danger is-rounded sale-tag">
                                    Oferta
                                </div>
                                <img :src="props.list.getImage" alt="imagen-subcategoria">
                            </div>
                            
                            <div class="card-content">
                                <div class="content product-content">
                                    <p class="has-text-weight-semibold">{{props.list.title}}</p>
                                    <div class="price has-text-centered">
                                        <p  style="text-decoration: line-through; color:#333;"  v-if="props.list.status=='O'">
                                            {{props.list.currencySymbol}} {{props.list.compareAt}}
                                        </p>
                                        <p class="has-text-custom ">{{props.list.currencySymbol}} {{props.list.price}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        </a>
                </template>
            </b-carousel-list>
        </div>

    </div>
    </div>
</template>

<script>

export default {

    props:{
        section:{
            type:Object,
            default:new Object({})
        }
    },
    data(){
        return{
            model:0
        }
    },
    methods:{
        redirectTo(link){
            window.location.href = link
        }
    }
}
</script>

<style lang="scss" scoped>
    .section-img{
        max-width:200px;
    }

    .section-title{
        color: var(--primary);
    }

    .card{
        height:100%;
        border:0px #fff solid !important;
        box-shadow: 0px 0px 0px 0px #b8b8b8;
        transition: all 1s;
    }
    a:hover {
        .card{
            box-shadow: 1px 10px 10px #b8b8b8;
            .card-image{
                img{
                    transform: scale(1.1);
                }
                .img-overlay{
                    opacity: 1;
                }
            }
        }
    }
    .card-image{
        overflow: hidden;
        img{
            max-height: 200px;
            transition: all 3s;
        }
    }
    .card-content{
        padding:5px;
    }
    .product-content{
        margin: 0px;
        p{
            margin:0px;
            padding:0px;
        }
    }

    .sale-tag{
        position:absolute;
        left:5px;
        top:5px;
        z-index:10;
    }
    .img-overlay{
        position:absolute;
        opacity:0;
        z-index:10;
        width:100%;
        height:100%;
        background: rgba(0, 0, 0, 0.2);
        transition: opacity 0.5s ease-in;
    }

    .img-overlay-btn{
        position: absolute;
        bottom: 20px;;
        left: 0;
        width: 100%;
    }

    .is-custom{
        background-color: var(--primary);
        color: var(--text-color);
    }

    .has-text-custom{
        color: var(--primary)
    }

</style>
